export default __webpack_public_path__ + "static/bg-boxes-757ef0393353ac551b663fa37f5c8f31.jpg";